<template>
  <div class="layout">
    <div class="navigation">
      <navigation />
    </div>
    <div class="main_left" >
      <div class="top">
        <div class="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index">{{ item }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="user">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              {{ user }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="exit">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- 内容部分 -->
      <div class="member-right-navbar">
        <app-main></app-main>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from './navigation.vue'
import AppMain from './AppMain.vue'
export default {
  components: {
    navigation,
    AppMain
  },
  data() {
    return {
      breadcrumbList: [],
      user: ''
    }
  },
  created() {
    this.breadcrumbList = this.$router.history.current.meta.title.split(',')
    console.log(this.$router.history)
    this.user = localStorage.getItem('username_b')
  },
  watch: {
    $route(e) {
      this.breadcrumbList = e.meta.title.split(',')
    }
  },
  methods: {
    exit() {
      this.$confirm('确定退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setTimeout(() => {
          localStorage.removeItem('username_b')
          localStorage.removeItem('token_b')
          localStorage.removeItem('value')
          localStorage.removeItem('index')
          localStorage.removeItem('progressNow')
          localStorage.removeItem('userType_b')
          this.$router.push('/login_b')
          this.$message({
            type: 'success',
            duration: 1000,
            showClose: true,
            message: '退出成功!'
          });
        }, 300)
      }).catch(() => {
        this.$message({
          type: 'info',
          duration: 1000,
          showClose: true,
          message: '已取消退出'
        });
      });
    }
  }
}
</script>

<style lang="less" scoped>
.layout {
  display: flex;
  justify-content: space-around;
  height: 100%;
}

.navigation {
  width: 10%;
  background-color: #232b3b;
}

.main_left {
  width: 90%;
  overflow: auto;

  .top {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #ddd;

    .user {
      display: inline-block;
      float: right;
      margin-right: 40px;

      /deep/.el-dropdown {
        color: #171717;
        font-weight: bold;
        font-size: 18px;
      }
    }
  }

  .breadcrumb {
    // background-color: #f8f8f8;
    // height: 50px;
    display: inline-block;
    // float: left;
    line-height: 50px;
    padding-left: 20px;

    /deep/.el-breadcrumb {
      display: inline-block;
    }
  }

  .member-right-navbar {
    /* height: calc(100vh - 50px); */
  }
}
</style>
